import { FC, useState } from 'react';
import { Box, Checkbox, Autocomplete } from '@mui/material';
import React from 'react';
import ArrowDropDownIcon from '@material-ui/icons/KeyboardArrowDown';
import { FormControl, makeStyles, TextField } from '@material-ui/core';

const useStyles = makeStyles({
  label: {
    fontWeight: 'bold',
    color: 'black',
    marginBottom: '10px',
    display: 'block',
    fontSize: '0.9rem',
  },

  input: {
    backgroundColor: '#fff',
    minHeight: '2rem',
    '& .MuiOutlinedInput-root': {
      borderRadius: '40px',
      backgroundColor: '#fff',
      minHeight: '2.5rem',
    },
    '& .MuiOutlinedInput-input': {
      padding: '6px 12px !important',
      fontSize: '0.9rem',
    },
    '& .MuiOutlinedInput-notchedOutline': {
      borderColor: '#000',
    },
    '&:hover .MuiOutlinedInput-notchedOutline': {
      borderColor: '#000',
    },
    '&.Mui-focused .MuiOutlinedInput-notchedOutline': {
      borderColor: '#000',
    },
  },
  option: {
    padding: '6px 12px',
  },
});

interface CustomSelectProps {
  handleOnchange: (value: string | string[]) => void;
  items: string[];
  label: string;
  type: 'default' | 'checkbox';
}

const CustomSelect: FC<CustomSelectProps> = ({
  handleOnchange,
  items,
  label,
  type,
}) => {
  const classes = useStyles();
  const [open, setOpen] = useState(false);
  const [isSelected, setIsSelected] = useState(false);
  const [selectedValues, setSelectedValues] = useState<string[]>([]);

  const handleChange = (
    _: React.SyntheticEvent<Element, Event>,
    value: string | string[] | null,
  ) => {
    if (type === 'checkbox') {
      setSelectedValues(prev => [...prev, value as string]);
    }
    setIsSelected(true);
    handleOnchange(value ?? (type === 'checkbox' ? [] : ''));
  };
  return (
    <Box pb={1} pt={1}>
      <label className={classes.label}>{label}</label>
      <FormControl fullWidth>
        <Autocomplete
          multiple={type === 'checkbox'}
          options={items}
          disableCloseOnSelect={type === 'checkbox'}
          clearIcon={false}
          open={open}
          onOpen={() => setOpen(true)}
          onClose={() => setOpen(false)}
          popupIcon={
            <ArrowDropDownIcon
              style={
                open
                  ? {
                      fontSize: '1.7rem',
                      color: 'grey',
                      marginLeft: '5px',
                      cursor: 'pointer',
                      transition: 'transform 0.25s ease-in-out',
                    }
                  : {
                      marginRight: '5px',
                    }
              }
            />
          }
          renderInput={params => (
            <TextField
              {...params}
              variant="outlined"
              InputProps={{
                ...params.InputProps,
                endAdornment: (
                  <Box
                    sx={{
                      display: 'flex',
                      alignItems: 'center',
                      justifyContent: 'center',
                      height: '9px',
                    }}
                  >
                    {params.InputProps.endAdornment}
                  </Box>
                ),
                style: {
                  maxHeight:
                    type === 'default'
                      ? '3rem'
                      : isSelected && type == 'checkbox'
                        ? undefined
                        : selectedValues.length < 1 && type == 'checkbox'
                          ? '3rem'
                          : '3rem',
                },
              }}
              className={classes.input}
            />
          )}
          onChange={handleChange}
          onClick={() => setOpen(e => !e)}
          onBlur={() => setOpen(false)}
          renderOption={(props, option, { selected }) => {
            const { key, ...restProps } = props; 
            return (
              <li key={key} {...restProps}>
                {' '}
                {type === 'checkbox' && <Checkbox checked={selected} />}
                {option}
              </li>
            );
          }}
          sx={{
            width: '100%',
            '& .MuiAutocomplete-popupIndicator': {
              display: 'flex',
              alignItems: 'center',
              justifyContent: 'center',
              p: 0,
              m: 0,
            },
            '& .MuiSvgIcon-root': {
              verticalAlign: 'middle',
            },
          }}
        />
      </FormControl>
    </Box>
  );
};

export default CustomSelect;
